import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        items: [
          {
            label: {
              value: "Unit Dimensions"
            },
            item: {
              node: "input",
              type: "checkbox",
              value: "",
              checked: false,
              intemName: "verifyDimensions"
            },
            size: "25%"
          },
          {
            label: {
              value: "Unit Verified"
            },
            item: {
              node: "input",
              type: "checkbox",
              value: "",
              intemName: "unitVerified",
              checked: false
            },
            size: "25%",
            readOnly: true
          },
          {
            label: {
              value: "Inner Verified"
            },
            item: {
              node: "input",
              type: "checkbox",
              value: "",
              intemName: "innerValidFlag",
              checked: false
            },
            size: "25%"
          },
          {
            label: {
              value: "Outer Verified"
            },
            item: {
              node: "input",
              type: "checkbox",
              value: "",
              intemName: "outerValidFlag",
              checked: false
            },
            size: "25%"
          }
        ]
      },
      {
        title: "Unit",
        items: [
          {
            label: {
              value: "Unit Weight",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "singleUnitWeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Unit Height",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "singleUnitHeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Unit Length",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "singleUnitLength"
            },
            size: "50%"
          },
          {
            label: {
              value: "Unit Cube",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "unitCubicMeasure"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Unit Width",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "singleUnitWidth"
            },
            size: "50%"
          }
        ]
      },
      {
        title: "Inner",
        items: [
          {
            label: {
              value: "Inner Weight",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "innerWeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Inner Height",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "innerHeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Inner Length",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "innerLength"
            },
            size: "50%"
          },
          {
            label: {
              value: "Inner Quantity",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "innerQty"
            },
            size: "50%"
          },
          {
            label: {
              value: "Inner Width",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "innerWidth"
            },
            size: "50%"
          }
        ]
      },
      {
        title: "Outer",
        items: [
          {
            label: {
              value: "Outer Weight",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              filter: "[^0-9][.]",

              intemName: "outerWeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Outer Height",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "outerHeight"
            },
            size: "50%"
          },
          {
            label: {
              value: "Outer Length",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "outerLength"
            },
            size: "50%"
          },
          {
            label: {
              value: "Outer Cube",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "outerCubicMeas"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Outer Width",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "outerWidth"
            },
            size: "50%"
          },
          {
            label: {
              value: "Outer Quantity",
              size: "60%"
            },
            item: {
              node: "input",
              filter: "[^0-9][.]",
              type: "string",
              value: "",
              intemName: "outerQty"
            },
            size: "50%"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.checked = props[c][inputName][i].checked;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
          }

          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);

    return (
      <Fragment>
        <div style={{ flex: 1 }}>
          <InputCard
            jsonObj={this.cardsLayout[0]}
            setCardsInfo={this.getCardsInfo}
          />
          <div style={{ flex: 1, display: "flex" }}>
            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[1]}
                setCardsInfo={this.getCardsInfo}
              />
            </div>
            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[2]}
                setCardsInfo={this.getCardsInfo}
              />
            </div>
            <div style={{ flex: 1 }}>
              <InputCard
                jsonObj={this.cardsLayout[3]}
                setCardsInfo={this.getCardsInfo}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  };

  render() {
    return (
      <Fragment>
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
